
import { FileX } from "lucide-react";

const ConversationEmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <FileX className="h-12 w-12 text-muted-foreground mb-4" />
      <h3 className="text-lg font-medium mb-1">No Conversation Data</h3>
      <p className="text-muted-foreground max-w-md">
        The conversation details could not be found or have not been loaded yet.
      </p>
    </div>
  );
};

export default ConversationEmptyState;
